import { useCallback } from 'react';
import axios from 'axios';

// Download newsletter PDFs with authenticated access
export function useNewsletterQnADownload({ instance, loginRequest }) {
    const downloadFile = useCallback(async (fileName) => {
        try {
            // Ensure the MSAL session is available before downloading
            if (!instance) {
                console.error('MSAL instance is undefined.');
                alert('Unable to access the authenticated session.');
                return;
            }

            const activeAccount = instance.getActiveAccount();

            if (!activeAccount) {
                console.warn('No active account. Please log in.');
                alert('No active account was found. Please log in again.');
                return;
            }

            // Request an access token for the protected data API
            const tokenResponse = await instance.acquireTokenSilent({
                ...loginRequest,
                account: activeAccount
            });

            // Build the authenticated download URL
            const fileURL = `${process.env.REACT_APP_API_ROOT_ENDPOINT}/v1/data/${fileName}`;

            const response = await axios.get(fileURL, {
                responseType: 'blob',
                headers: {
                    Authorization: `Bearer ${tokenResponse.accessToken}`
                },
                timeout: 60000
            });

            // Convert the response into a browser-openable file
            const blob = new Blob([response.data], {
                type: response.headers['content-type'] || 'application/pdf'
            });

            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');

            setTimeout(() => {
                window.URL.revokeObjectURL(url);
            }, 60000);
        } catch (error) {
            console.error('Error opening the file:', error);
            alert('Failed to open the file. Please try again.');
        }
    }, [instance, loginRequest]);

    return { downloadFile };
}
